import { getIriAll } from '../../thing/get.mjs';
import { getThing } from '../../thing/thing.mjs';
import { internal_getAcr } from '../control.internal.mjs';

//
/** @hidden */
function getPolicyUrls(resource, accessControlUrls, type) {
    const acr = internal_getAcr(resource);
    return Array.from(new Set(accessControlUrls
        .map((accessControlUrl) => {
        const accessControlThing = getThing(acr, accessControlUrl);
        // istanbul ignore next
        if (accessControlThing !== null) {
            return getIriAll(accessControlThing, type);
        }
        // istanbul ignore next
        return [];
    })
        .reduce((previousValue, currentValue) => previousValue.concat(currentValue), [])));
}

export { getPolicyUrls };
